import { toUrlFormat } from '../../../utils/treeVisitors';
import { removeStartingSlash } from '../../../utils/locationUtils';
import { getFirstCategoryKey } from '../App/utils';
import { getNodeByLink } from '../../../Store/Utils/treeUtils';
import { TYPES } from '../../../utils/flattenTree/utils/consts';
import { getOperationMenuName } from '../../../utils';
import { getName } from '../../../utils/treeVisitors/helpers';

export const generateBreadcrumbsObjectsFromNodeKey = (
  url = '',
  fullTree = {},
  layoutType,
) => {
  if (!url) {
    return [];
  }

  const urlKeys = removeStartingSlash(url)
    .split('/')
    .map((key) => `/${key}`);

  return urlKeys.reduce((items, key, i) => {
    const nodeLink = urlKeys.slice(0, i + 1).join('');
    const node = getNodeByLink(fullTree, nodeLink);
    if (node?.data) {
      const JSLayoutType = node.data?.layoutType === 'JS';
      const { link, propType } = node.data;

      const name = getName(node.data);

      const displayName =
        propType === TYPES.OPERATION || propType === TYPES.CLIENT_EVENT
          ? getOperationMenuName(name, layoutType, JSLayoutType)
          : name;

      return [...items, { link, displayName }];
    }
    return items;
  }, []);
};

export const getHomePageUrl = (store) => {
  const firstKey = getFirstCategoryKey(store);
  return `${toUrlFormat(firstKey)}`;
};

export const getBreadcrumbsUrl = (store, activeLink, homePageUrl) => {
  if (activeLink === '/') {
    return homePageUrl;
  }
  if (activeLink.startsWith('/#')) {
    const firstKey = getFirstCategoryKey(store);
    return `${toUrlFormat(firstKey)}#`;
  }
  return activeLink;
};
